import { getSections } from './helpers.js'

const entity = {
  name: {
    singular: 'Seção',
    plural: 'Seções'
  },
  collection: 'sections',
  tableHeaders: [
    { text: 'Seção', value: 'title' },
    { text: 'Url Amigável', value: 'slug' },
    { text: 'Actions', value: 'action', sortable: false }
  ],
  model: {
    parent: null,
    slug: null,
    title: null,
    type: 'list'
  },
  schema: {
    groups: [
      {
        fields: [
          {
            type: 'checklist',
            label: 'Seções',
            model: 'parent',
            multi: false,
            values: getSections()
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Título',
            model: 'title',
            required: true
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Url amigável',
            model: 'slug',
            required: true
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Posição',
            model: 'position',
            required: true
          }
        ]
      },
      {
        fields: [
          {
            type: 'image',
            label: 'Imagem grande',
            model: 'fileMainImage',
            required: false,
            hideInput: true
          },
          {
            type: 'image',
            label: 'Imagem pequena',
            model: 'fileSecondaryImage',
            required: false,
            hideInput: true
          }
        ]
      }
    ]
  },
  formOptions: {
    validateAfterLoad: false,
    validateAfterChanged: false,
    validateAsync: false
  }
}

export default [
  {
    path: '/sections',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "sections" */ '../../components/Crud/CrudList.vue')
  }, {
    path: '/sections/new',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "sections" */ '../../components/Crud/CrudForm.vue')
  }, {
    path: '/sections/:id',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "sections" */ '../../components/Crud/CrudForm.vue')
  }
]
